<template src="./App.html"></template>
<style lang="scss" src="../assets/scss/_customs.scss"></style>

<script>
import BaseApp from '@/BaseApp'
import Cookie from 'js-cookie'
import { mapState } from 'vuex'
import { initGTM } from '@/helper'
import AppFooter from '@/components/layout/AppFooter'
import CookieOverlay from '@/components/overlays/CookieOverlay'

export default {
  components: {
    AppFooter,
    CookieOverlay,
  },
  mixins: [BaseApp],
  data() {
    return {
      show_cookie_layer: false,
    }
  },
  computed: {
    ...mapState('auth', ['settings']),
  },
  created() {
    initGTM(this.$gtm)
  },
  updated() {
    const cdisc = Cookie.get('cdisc')
    this.show_cookie_layer = !(cdisc && cdisc === 'true')
  },
}
</script>
